import {LandingComponent} from '@app/landing/landing.component';
import {NoPreloading, RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {SignupComponent} from '@app/signup/signup.component';
import {LoginComponent} from '@app/login/login.component';
import {ImpressumComponent} from '@app/sites/impressum/impressum.component';
import {PrivacyComponent} from '@app/sites/privacy/privacy.component';
import {TermsOfUseComponent} from '@app/sites/terms-of-use/terms-of-use.component';
import {InterviewComponent} from '@app/sites/nico-rosberg-interview/interview.component';
import {AuthenticatedUserGuard} from '@common/messe-ui-toolkit';
import {AppValidateComponent} from '@dashboard/app-validate/app-validate.component';
import {MaintenanceComponent} from '@app/sites/maintenance/maintenance.component';
import {environment} from '@environments/environment';
import {ErrorComponent} from '@app/error-site/error.component';
import {STARTUP_DASHBOARD_ROUTES} from '@dashboard/dashboard-routing';
import {MA_DASHBOARD_ROUTES} from '@ma-dashboard/ma-dashboard-routing';
import {HP_DASHBOARD_ROUTES} from '@hp-dashboard/hp-dashboard-routing';
import {AppRelativeRouteBuilder, RouteBuilder} from '@util/route-builder';
import {PlatformMigrationMaintenanceComponent} from '@app/sites/platform-migration-maintenance/platform-migration-maintenance.component';

const defaultRoutes: Routes = [
  {path: RouteBuilder.buildRelative(), component: LandingComponent},
  {path: RouteBuilder.signup().buildRelative(), component: SignupComponent},
  {path: RouteBuilder.imprint().buildRelative(), component: ImpressumComponent},
  {path: RouteBuilder.privacy().buildRelative(), component: PrivacyComponent},
  {path: RouteBuilder.termsOfUse().buildRelative(), component: TermsOfUseComponent},
  {path: RouteBuilder.interview().buildRelative(), component: InterviewComponent},
  {path: RouteBuilder.error().buildRelative(), component: ErrorComponent},
  {
    path: RouteBuilder.app().buildRelative(),
    component: AppValidateComponent,
    canActivate: [AuthenticatedUserGuard],
    children: [
      {
        path: AppRelativeRouteBuilder.startupDashboard().buildRelative(),
        children: STARTUP_DASHBOARD_ROUTES,
      },
      {
        path: AppRelativeRouteBuilder.maDashboard().buildRelative(),
        children: MA_DASHBOARD_ROUTES,
      },
      {
        path: AppRelativeRouteBuilder.hpDashboard().buildRelative(),
        children: HP_DASHBOARD_ROUTES,
      },
    ],
  },
  {path: RouteBuilder.login().buildRelative(), component: LoginComponent, canActivate: [AuthenticatedUserGuard]},
  {path: '**', redirectTo: RouteBuilder.buildRelative()},
];

const maintenanceRoutes: Routes = [{path: '**', component: MaintenanceComponent}];

@NgModule({
  imports: [
    RouterModule.forRoot(loadRoutes(environment.maintenanceMode, environment.maintenanceForRegistration), {
      urlUpdateStrategy: 'eager',
      enableTracing: false,
      preloadingStrategy: NoPreloading,
      scrollPositionRestoration: 'disabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}

export function loadRoutes(maintenanceMode: boolean, maintenanceForRegistration: boolean): Routes {
  if (maintenanceMode) {
    return maintenanceRoutes;
  }
  if (maintenanceForRegistration) {
    return defaultRoutes.map((route) => {
      if (route.path === RouteBuilder.signup().buildRelative()) {
        return {...route, component: PlatformMigrationMaintenanceComponent};
      }
      return route;
    });
  }
  return defaultRoutes;
}
